export const runAllWithData = function setFunctions(...fns) {
  return function runAllFunctionsWithSameData(data) {

    fns.forEach((fn) => fn(data));
  };
};
